import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/gg': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M179.2 230.4l102.4 102.4-102.4 102.4-179.2-179.2 179.2-179.2 44.8 44.8-25.6 25.6-19.2-19.2-128 128 128 128 51.5-51.5-77.1-76.5zM332.8 76.8l179.2 179.2-179.2 179.2-44.8-44.8 25.6-25.6 19.2 19.2 128-128-128-128-51.5 51.5 77.1 76.5-25.6 25.6-102.4-102.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/brands/gg.js
// module id = null
// module chunks = 